import { CognitoUserSession } from 'amazon-cognito-identity-js';

import getDecodedToken from './get-decoded-token';

const getSessionProviderName = (currentSession: CognitoUserSession) => {
    const decodedToken = getDecodedToken(currentSession);

    if (!decodedToken.identities?.length) {
        return '';
    }

    return decodedToken.identities[0].providerName;
};

export default getSessionProviderName;
